import { DropdownMenu } from '@octopus-do/octopus-storybook'
import { AngleDown } from '@octopus-do/octopus-storybook/icons'
import React from 'react'

import css from './styles.module.css'

interface Props {
  label: string
  disabled: boolean
}

export const MemberButton = React.forwardRef<HTMLButtonElement, Props>(
  ({ label, disabled }, ref) => {
    const { open } = DropdownMenu.useTrigger()

    if (disabled) {
      return <div className={css.static}>{label}</div>
    }

    return (
      <button
        disabled={disabled}
        ref={ref}
        onPointerDown={open}
        className={css.trigger}
      >
        {label}
        <AngleDown />
      </button>
    )
  }
)
